import { AgGridReact } from 'ag-grid-react';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { schformdelete, schformlist } from '../../../../services/superadmin';
import moment from 'moment';
import dotracking from '../../../trackinglogs';
import trackobj from "../../../trackingpages.json"
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { funderprofile, funderschformlist } from '../../../../services/funder';
import { cityschformlist } from '../../../../services/cityregionaladmin';
export const Listscholarship = () => {
    const [filterProduct, setFilterProduct] = useState([]);
    const navigate = useNavigate();
    const columnDefs = [
        {
            headerName: "Form Name",
            field: "form_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Entry State Date",
            field: "form_entry_start_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Entry End Date",
            field: "form_entry_end_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Form URL",
            field: "form_url",
            width: 120,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellRenderer: function (params) {
                if (params.value !== "") {
                    return (
                        <div className="text-center">
                            <a onClick={() => loginurl(params.value)}
                                className="btn-sm btn-success"
                            >
                                Visit Form
                            </a>
                        </div>
                    );
                }
            },
        },
        {
            headerName: "Actions",
            field: "id",
            resizable: true,
            filter: false,
            cellRenderer: function (params) {
                if (localStorage.getItem("Role") === '8' || localStorage.getItem("Role") === '3') {
                    return (
                        <div className='text-center'>

                            <a
                                title="Edit Forms"
                                onClick={() => viewform(params)}
                                className="btn-sm btn-secondary me-1"
                            >
                                <i className="fa fa-eye fa-lg"></i>
                            </a>
                            <a
                                title="Registered Form List"
                                onClick={() => registeredlist(params)}
                                className="btn-sm btn-success"
                            >
                                <i className="fa fa-users fa-lg"></i>
                            </a>
                        </div>
                    );
                } else {
                    return (
                        <div className='text-center'>
                            <a
                                title="List Competition"
                                onClick={() => listtype(params)}
                                className="btn-sm btn-warning me-1"
                            >
                                <i className="fa fa-list fa-lg"></i>
                            </a>
                            <a
                                title="Edit Forms"
                                onClick={() => viewform(params)}
                                className="btn-sm btn-secondary me-1"
                            >
                                <i className="fa fa-edit fa-lg"></i>
                            </a>
                            <a
                                title="Funder List"
                                onClick={() => listfun(params)}
                                className="btn-sm btn-gray me-1"
                            >
                                <i className="fa fa-list fa-lg"></i>
                            </a>
                            <a
                                title="Delete Forms"
                                onClick={() => deleteform(params)}
                                className="btn-sm btn-danger me-1"
                            >
                                <i className="fa fa-trash fa-lg"></i>
                            </a>
                            <a
                                title="Registered Form List"
                                onClick={() => registeredlist(params)}
                                className="btn-sm btn-success"
                            >
                                <i className="fa fa-users fa-lg"></i>
                            </a>
                        </div>
                    );
                }

            },
        },
    ]
    function listfun(ldata) {
        dotracking(
            "funder list in scholarship form list for " +
            ldata.data.form_name +
            " (" +
            ldata.data.id +
            ") $$ " +
            trackobj.formfunderheading
        );
        navigate("/superadmin/formfunderlist/" + ldata.data.id)
    }
    function loginurl(ldata) {
        const url = window.location.href;
        const head = url.split("/#/");
        window.open(`${head[0]}/#/` + ldata, "_blank");
    }

    useEffect(() => {
        listall();
    }, []);

    function listall() {
        setFilterProduct([]);
        if (localStorage.getItem("Role") === '1') {
            schformlist().then((res) => {
                if (res.status === true) {
                    const sdata = res.data.scholarship_forms.map((item) => ({
                        ...item,
                        form_entry_start_date: moment(item.form_entry_start_date).format("DD-MM-YYYY"),
                        form_entry_end_date: moment(item.form_entry_end_date).format("DD-MM-YYYY"),
                        form_status: item.form_status == 1 ? 'Active' : 'Inactive',
                    }));
                    setFilterProduct(sdata)
                }
            })
        } else if (localStorage.getItem("Role") === '8') {
            funderprofile().then((res1) => {
                if (res1.status === true) {
                    funderschformlist(res1.data.funder_id).then((res) => {
                        if (res.status === true) {
                            const sdata = res.data.scholarship_forms.map((item) => ({
                                ...item,
                                form_entry_start_date: moment(item.form_entry_start_date).format("DD-MM-YYYY"),
                                form_entry_end_date: moment(item.form_entry_end_date).format("DD-MM-YYYY"),
                                form_status: item.form_status == 1 ? 'Active' : 'Inactive',
                            }));
                            setFilterProduct(sdata)
                        }
                    })
                }
            })
        }else if (localStorage.getItem("Role") === '3') {
            cityschformlist(localStorage.getItem("UID")).then((res) => {
                if (res.status === true) {
                    const sdata = res.data.scholarship_forms.map((item) => ({
                        ...item,
                        form_entry_start_date: moment(item.form_entry_start_date).format("DD-MM-YYYY"),
                        form_entry_end_date: moment(item.form_entry_end_date).format("DD-MM-YYYY"),
                        form_status: item.form_status == 1 ? 'Active' : 'Inactive',
                    }));
                    setFilterProduct(sdata)
                }
            })
        }
    }
    function listtype(ldata) {
        dotracking(
            "list competition type button in scholarship form list for " +
            ldata.data.form_name +
            " (" +
            ldata.data.id +
            ") $$ " +
            trackobj.formcompheading
        );
        navigate("/superadmin/formcompetitiontype/" + ldata.data.id)
    }
    function viewform(ldata) {
        dotracking(
            "edit button in scholarship form list for " +
            ldata.data.form_name +
            " (" +
            ldata.data.id +
            ") $$ " +
            trackobj.schdetheading
        );
        
        if (localStorage.getItem("Role") === '8') {
            navigate("/funder/viewschloarship/" + ldata.data.id)
        }else if (localStorage.getItem("Role") === '3') {
            navigate("/cityregional/viewschloarship/" + ldata.data.id)
        } else {
            navigate("/superadmin/editscholarshipform/" + ldata.data.id)
        }
    }
    function deleteform(list) {
        Swal.fire({
            text: "Are you sure want to delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                dotracking(
                    "delete button in scholarship form list for " +
                    list.data.form_name +
                    " (" +
                    list.data.id +
                    ") $$ " +
                    trackobj.schlistheading
                );
                schformdelete(list.data.id).then((response) => {
                    if (response.status === true) {
                        listall();
                        toast.success(response.message);
                    }
                });
            }
        });

    }

    function registeredlist(ldata) {
        dotracking(
            "registered form list button in scholarship form list for " +
            ldata.data.form_name +
            " (" +
            ldata.data.id +
            ") $$ " +
            trackobj.formlistheading
        );
        if (localStorage.getItem("Role") === '8') {
            navigate("/funder/formregisterlist/" + ldata.data.id)
        }else if (localStorage.getItem("Role") === '3') {
            navigate("/cityregional/formregisterlist/" + ldata.data.id)
        } else {
            navigate("/superadmin/formregisterlist/" + ldata.data.id)
        }
    }
    return (
        <div className="side-app">
            <div className="page-header">
                <div className="breadcrumb">
                    <h4 className="mb-0">Scholarship List</h4>
                </div>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Scholarship</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Scholarship List
                    </li>
                </ol>
            </div>
            <form className="card mt-0">
                <div className="card-body">
                    <div className="ag-theme-alpine ag-style mt-2">
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={filterProduct}
                            pagination="true"
                            paginationPageSize="10"
                            sortingOrder={["asc", "desc"]}
                            suppressExcelExport={true}
                            suppressDragLeaveHidesColumns={true}
                        // }}
                        />
                    </div>
                </div>
            </form>
        </div>
    )
}
